export default "__VITE_ASSET__Djo6wSSD__"